import i18next from 'i18next'
import { loadingAsyncState } from 'widgets-for-react'
import { canSafelyCast } from '../../../../utils/safe-type-casting'
import { dishTeaserValidator } from '../dishTeasers/dishTeasersApi'
import { DishTeaserData } from '../dishTeasers/dishTeasersState'

export const loadDishHighlight = (id: number) =>
  loadingAsyncState(() =>
    getDishTeaserById(id).then((raw) => {
      if (raw == null) return { kind: 'result', value: undefined, status: 200 }
      const validationResult = canSafelyCast<DishTeaserData>(
        dishTeaserValidator,
        raw
      )
      return validationResult.kind == 'r'
        ? { kind: 'result', value: validationResult.v, status: 200 }
        : { kind: 'failed', status: 404 }
    })
  )

async function getDishTeaserById(dishId: number): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(
    `/api/v1/dishes/teasers?dishIds=${dishId}&language=${i18next.language}`,
    { method: 'get', headers: headers }
  )
  if (!res.ok) 
  {
    if (res.status == 404) return null
    throw Error(res.statusText)
  }
  return await res.json().then((arr) => arr?.[0])
}
